import { BaseScene } from './BaseScene';
import { SceneKey } from './sceneKeys';
import { GAME_WIDTH, GAME_HEIGHT } from './gameConfig';
import { GameMode } from '../types/GameMode';
import { BackgroundImageKey } from '../constants/imageKeys';

const VERSUS_SELECT_BUTTONS = [
  {
    label: '対CPU',
    targetScene: SceneKey.CHARACTER_SELECT,
    mode: GameMode.FREE_CPU,
  },
  {
    label: '対CPU（3vs3）',
    targetScene: SceneKey.CHARACTER_SELECT,
    mode: GameMode.FREE_CPU_3V3,
  },
  {
    label: 'フレンド対戦',
    targetScene: SceneKey.MODE_SELECT,
    mode: GameMode.FREE_LOCAL,
  },
  {
    label: '観戦',
    targetScene: SceneKey.CHARACTER_SELECT,
    mode: GameMode.SPECTATOR,
  },
  {
    label: '戻る',
    targetScene: SceneKey.BATTLE_MODE_SELECT,
  },
];

/**
 * 対戦種別選択画面シーン
 *
 * 対CPU / 対CPU(3vs3) / フレンド対戦 / 観戦 / 戻る を表示する。
 */
export class VersusSelectScene extends BaseScene {
  constructor() {
    super(SceneKey.VERSUS_SELECT);
  }

  create(): void {
    this.cameras.main.fadeIn(300, 0, 0, 0);

    if (this.textures.exists(BackgroundImageKey.TITLE)) {
      this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, BackgroundImageKey.TITLE).setOrigin(0.5);
    }

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT * 0.2, '対戦', {
        fontSize: '40px',
        color: '#ffffff',
        fontFamily: "'Noto Sans JP', Arial, sans-serif",
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    const startY = GAME_HEIGHT * 0.4;
    const spacing = 60;

    VERSUS_SELECT_BUTTONS.forEach((buttonConfig, index) => {
      const y = startY + index * spacing;

      const text = this.add
        .text(GAME_WIDTH / 2, y, buttonConfig.label, {
          fontSize: '28px',
          color: '#ffffff',
          fontFamily: "'Noto Sans JP', Arial, sans-serif",
          stroke: '#000000',
          strokeThickness: 5,
        })
        .setOrigin(0.5)
        .setInteractive({ useHandCursor: true });

      text.on('pointerover', () => text.setScale(1.1));
      text.on('pointerout', () => text.setScale(1.0));
      text.on('pointerdown', () => {
        this.transitionTo(buttonConfig.targetScene, {
          mode: buttonConfig.mode,
        });
      });
    });
  }
}
